<template>
  <div class="ohra-details-card">
    <div class="card-header">
      <h4>{{ $t('globals.items_created_vs_fulfilled') }}</h4>
      <div class="refresh-button" @click="fetchData">
        <icon name="sync-alt" :spin="isLoading"></icon>
      </div>
    </div>

    <div class="card-content">
      <div class="stats-row">
        <div class="stats-label">
          {{ $t("globals.boxes") }}:
        </div>
        <div class="stats-value">
          <icon v-if="orders_loading" name="spinner" spin class="spinner-small"></icon>
          <span v-else class="value-created">{{ items.box }}</span>
          <span class="separator">/</span>
          <icon v-if="orders_loading_fulfilled" name="spinner" spin class="spinner-small"></icon>
          <span v-else class="value-fulfilled">{{ items.box_fulfilled }}</span>
        </div>
      </div>

      <div class="stats-row">
        <div class="stats-label">
          {{ $t("globals.dongles") }}:
        </div>
        <div class="stats-value">
          <icon v-if="orders_loading" name="spinner" spin class="spinner-small"></icon>
          <span v-else class="value-created">{{ items.devices }}</span>
          <span class="separator">/</span>
          <icon v-if="orders_loading_fulfilled" name="spinner" spin class="spinner-small"></icon>
          <span v-else class="value-fulfilled">{{ items.devices_fulfilled }}</span>
        </div>
      </div>

      <div class="stats-row">
        <div class="stats-label">
          {{ $t("globals.cables") }}:
        </div>
        <div class="stats-value">
          <icon v-if="orders_loading" name="spinner" spin class="spinner-small"></icon>
          <span v-else class="value-created">{{ items.cables }}</span>
          <span class="separator">/</span>
          <icon v-if="orders_loading_fulfilled" name="spinner" spin class="spinner-small"></icon>
          <span v-else class="value-fulfilled">{{ items.cables_fulfilled }}</span>
        </div>
      </div>

      <div class="stats-row">
        <div class="stats-label">
          {{ $t("globals.gps_only_cables") }}:
        </div>
        <div class="stats-value">
          <icon v-if="orders_loading" name="spinner" spin class="spinner-small"></icon>
          <span v-else class="value-created">{{ items.gps_cables }}</span>
          <span class="separator">/</span>
          <icon v-if="orders_loading_fulfilled" name="spinner" spin class="spinner-small"></icon>
          <span v-else class="value-fulfilled">{{ items.gps_cables_fulfilled }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import "vue-awesome/icons/spinner";
import "vue-awesome/icons/sync-alt";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue")
  },
  props: {
    range: Array
  },
  data() {
    return {
      items: {
        box: 0,
        box_fulfilled: 0,
        devices: 0,
        devices_fulfilled: 0,
        gps_cables: 0,
        gps_cables_fulfilled: 0,
        cables: 0,
        cables_fulfilled: 0
      },
      orders_loading: true,
      orders_loading_fulfilled: true
    };
  },
  methods: {
    ...mapActions(["noSynatecOhraOrders"]),
    fetchNumberOfDevices() {
      this.orders_loading = true;
      this.orders_loading_fulfilled = true;

      this.noSynatecOhraOrders({ range: this.range, status: "created" })
        .then(res => {
          // Reset created values to 0 before processing
          this.items.box = 0;
          this.items.cables = 0;
          this.items.gps_cables = 0;
          this.items.devices = 0;

          if (res) {
            var reference_this = this;
            res.data.data.noSynatecOrdersCreated.forEach(function (item, index) {
              if(item.name == 'ULU-COLLI-OHRA') {
                reference_this.items.box = item.count;
              } else if(item.name == 'ULU-EXT-CABLE') {
                reference_this.items.cables = item.count;
              } else if(item.name == 'ULU-GPSONLY-EXTCABLE') {
                reference_this.items.gps_cables = item.count;
              } else if(item.name == 'ULU-VEL10-OHRA') {
                reference_this.items.devices = item.count;
              }
            });
          }
        })
        .finally(() => {
          this.orders_loading = false;
        });

      this.noSynatecOhraOrders({ range: this.range, status: "fulfilled" })
        .then(res => {
          // Reset fulfilled values to 0 before processing
          this.items.box_fulfilled = 0;
          this.items.cables_fulfilled = 0;
          this.items.gps_cables_fulfilled = 0;
          this.items.devices_fulfilled = 0;

          if (res) {
            var reference_this = this;
            res.data.data.noSynatecOrdersFulfilled.forEach(function (item, index) {
              if(item.name == 'ULU-COLLI-OHRA') {
                reference_this.items.box_fulfilled = item.count;
              } else if(item.name == 'ULU-EXT-CABLE') {
                reference_this.items.cables_fulfilled = item.count;
              } else if(item.name == 'ULU-GPSONLY-EXTCABLE') {
                reference_this.items.gps_cables_fulfilled = item.count;
              } else if(item.name == 'ULU-VEL10-OHRA') {
                reference_this.items.devices_fulfilled = item.count;
              }
            });
          }
        })
        .finally(() => {
          this.orders_loading_fulfilled = false;
        });


    },
    fetchData() {
      this.fetchNumberOfDevices();
    }
  },
  computed: {
    ...mapGetters(["getUserSystem"]),
    isLoading() {
      return (
        this.orders_loading && this.orders_loading_fulfilled
      );
    }
  },
  watch: {
    getUserSystem: function() {
      this.fetchData();
    },
    range: function() {
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style scoped>
.ohra-details-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e2e8f0;
}

.card-header h4 {
  margin: 0;
  color: #2d3748;
  font-size: 1.1em;
  font-weight: 600;
}

.refresh-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  color: #4a5568;
  transition: all 0.2s;
}

.refresh-button:hover {
  background-color: #edf2f7;
  border-color: #5469d4;
  color: #5469d4;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.stats-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #5469d4;
  transition: background-color 0.2s;
}

.stats-row:hover {
  background-color: #e9ecef;
}

.stats-label {
  font-weight: 500;
  color: #4a5568;
  font-size: 0.95em;
}

.stats-value {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1em;
  font-weight: 600;
}

.value-created {
  color: #28a745;
}

.value-fulfilled {
  color: #007bff;
}

.separator {
  color: #a0aec0;
  font-weight: 500;
}

.spinner-small {
  font-size: 14px;
  color: #5469d4;
}

@media (max-width: 768px) {
  .ohra-details-card {
    padding: 15px;
  }

  .stats-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 12px;
  }

  .stats-value {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
